/** True when REACT_APP_SITE_PASSWORD is set — private preview mode (app gate + closed signups). */
export function isPrivatePreviewActive() {
  return Boolean(String(process.env.REACT_APP_SITE_PASSWORD || "").trim());
}

export function getSitePreviewPassword() {
  return String(process.env.REACT_APP_SITE_PASSWORD || "").trim();
}
